export default __webpack_public_path__ + "static/g404-87b1cc687ffdd5b06e68891edfdec8a3.jpg";